import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BankDetails } from '../models/bank-details.model';
import { BankResponseType } from '../enums/bank-response-type.enum';
import { BankConfirmationResult } from '../models/bank-confirmation-result.model';

@Component({
  selector: 'app-bank-verification-confirmation',
  templateUrl: './bank-verification-confirmation.component.html',
  styleUrl: './bank-verification-confirmation.component.scss'
})
export class BankVerificationConfirmationComponent implements OnInit {
  @Input() bankDetails: BankDetails;
  title: string;
  message: string;
  responseTypes = BankResponseType;
  isMatch: boolean;
  isCloseMatch: boolean;
  isNoMatch: boolean;
  canEdit: boolean;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    if (this.bankDetails.responseType === BankResponseType.Match) {
      this.title = 'Match';
      this.message = `The details you have entered match.`;
    } else if (this.bankDetails.responseType === BankResponseType.CloseMatch) {
      this.title = 'Close Match';
      this.message = `This is a close match. Do you want to change it to: <b>${this.bankDetails.closeMatchName}</b>`;
    } else if (this.bankDetails.responseType === BankResponseType.NoMatch) {
      this.title = 'No Match';
      this.message = `The details you entered do not match the customer's name. Please amend this to avoid a delay in payment.`;
    } else {
      this.title = 'Bank Details Not Valid';
      this.message = `The details you've entered are not valid, please check and try again.`;
    }
    this.isMatch = this.bankDetails.responseType === BankResponseType.Match;
    this.isCloseMatch = this.bankDetails.responseType === BankResponseType.CloseMatch;
    this.isNoMatch = this.bankDetails.responseType === BankResponseType.NoMatch;
    this.canEdit = !this.isMatch && !this.isCloseMatch;
  }

  continuePurchase() {
    const result = new BankConfirmationResult(true, null);
    this.activeModal.close(result);
  }

  updateNameAndContinue() {
    const result = new BankConfirmationResult(true, this.bankDetails.closeMatchName);
    this.activeModal.close(result);
  }

  stayOnPage() {
    const result = new BankConfirmationResult(false, null);
    this.activeModal.close(result);
  }
}
